import { LinkButton } from '@e3dc-react/shell/Elements/Buttons'
import { Typography, useTheme } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { useTypedSelector } from 'src/State/RootReducer'
import { SERVICE_LEVELS } from '../../Configuration/user'
import { Installation } from 'src/Libs/installations/models/installation.model'
import { getOwnerName } from 'src/Libs/installations/installation.functions'
import { isFlowTheme } from 'src/Libs/utils'

const useStyles = makeStyles()(() => ({
  wordBreak: {
    display: 'block',
    wordBreak: 'break-word',
  },
}))

interface OwnerLinkProps {
  installation: Installation
}

/*
 * The component renders a clickable link or a placeholder based on the user's service level
 */
const OwnerLink: React.FC<OwnerLinkProps> = ({ installation }) => {
  const { classes } = useStyles()
  const theme = useTheme()
  const userLevel = useTypedSelector(store => store.user.userData?.level) || 'USER'
  const isServiceUser = SERVICE_LEVELS.includes(userLevel)
  const ownerName = getOwnerName(installation)
  const ownerAccountType = installation?.ownerAccountType

  const getOwnerLinkTarget = (): string => {
    if (ownerAccountType === 'company') {
      return `/overview/companies/${installation.ownerAccountId}`
    }

    if (ownerAccountType === 'user') {
      return `/overview/users/${installation.ownerAccountId}`
    }

    return ''
  }

  if (isServiceUser && ownerName !== '---' && !isFlowTheme) {
    return (
      <LinkButton
        content={ownerName}
        linkColor={theme.palette.primary.main}
        hasUnderline={false}
        link={getOwnerLinkTarget()}
        clickable={!!installation.ownerAccountId}
        dataQa={`button-installation-id-${installation.ownerAccountId}`}
        linkClassName={classes.wordBreak}
      />
    )
  }

  return (
    <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
      {ownerName}
    </Typography>
  )
}

export default OwnerLink
